<template lang="pug">
  GlobalDialog(
    v-model='showModal',
    max-width='957px',
    scrollable,
    :headerTitle='title',
    :showMButton="!viewingMode",
    :showLButton='false',
    mButtonColor='#A8A8A8',
    mButtonTextColor='#FFFFFF',
    :mButtonIsOutlined='false',
    :mButtonTitle='$t("commonWords.cancel")',
    @clickMButton='showModal = false',
    :showRButton="!viewingMode",
    :rButtonTitle='$t("commonWords.save")',
    @clickRButton='saveData()'
  )
    template(slot='content')
      div(v-if="loading" style='display: flex; justify-content: center; align-items: center; height: 100%;')
        v-progress-circular(
          size='120'
          width='4'
          indeterminate
          color='rgba(200, 200, 200, 0.7)')
          b(style='font-size: 14px; color: rgba(200, 200, 200, 0.7)') {{$t('selectWorkspaces.loading')}}
      div(v-else)
        Tree(
          ref="treeView"
          :value='tree'
          :viewingMode='viewingMode'
          :is-parent="true"
          @change="updateTextProp($event)"
        )

</template>

<script>
import GlobalDialog from '@/components/Reuse/GlobalDialog.vue'
import TreeView from '@/components/TreeNode.vue'
import Tree from '@/components/SimplifiedChatbuilder/Tree.vue'
import Swal from 'sweetalert2'

export default {
  name: 'EditNodeModal',
  components: { Tree, GlobalDialog, TreeView },
  computed: {
    title () {
      if (this.viewingMode) {
        return this.$t('snapshots.viewModalTitle')
      }
      return this.$t('snapshots.editModalTitle')
    },
    showModal: {
      get () {
        return this.displayModal
      },
      set (val) {
        this.$emit('update:displayModal', val)
      }
    }
  },
  props: {
    displayModal: {
      type: Boolean,
      default: false
    },
    nodeId: {
      type: String,
      default: ''
    },
    workspaceId: {
      type: String,
      default: ''
    },
    snapshotId: {
      type: String,
      default: ''
    },
    viewingMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      editMode: false,
      nodeMap: null,
      tree: null,
      loading: false,
      nodes: [],
      nodeTextOutput: '',
      nodeData: {}
    }
  },
  async created () {
    if (this.nodeId) {
      await this.fetchNodeData(this.nodeId)
    }
  },
  methods: {
    updateTextProp (event) {
      this.nodeTextOutput = event
      this.$store.commit('snapshots/setHasChanges', true)
      this.$store.commit('snapshots/latestSnapshotState', 'checkedout')
    },
    async saveData () {
      try {
        await
        this.$axios.put(`${process.env.VUE_APP_BACKEND_BASE_URL}/chatbuilder/${this.workspaceId}/${this.snapshotId}/${this.nodeId}`, {
          text: this.nodeTextOutput
        })
        this.showModal = false
        this.$emit('updated-node')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest'),
          text: 'error',
          showConfirmButton: true
        })
      }
    },
    async fetchNodeData (nodeId) {
      try {
        this.loading = true
        const response = await this.$axios.get(`${process.env.VUE_APP_BACKEND_BASE_URL}/chatbuilder/${this.workspaceId}/${this.snapshotId}/${nodeId}`)
        this.tree = response.data.tree[0]
        this.loading = false
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: this.$t('snapshots.thereWasAnErrorInYourRequest'),
          text: 'error',
          showConfirmButton: true
        })
      }
    }
  },
  watch: {
    async nodeId (val) {
      await this.fetchNodeData(val)
    },
    tree: {
      handler (val) {
        this.$emit('update:tree', val)
      },
      deep: true
    }
  }
}
</script>
